import { List } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ComplexFireIcon } from 'features/mapping/icons';
import * as wildfireIcons from 'features/mapping/icons/iconData/wildfireIcons';
import { LegendListItem } from './LegendListItem';
import { LegendSectionTitle } from './LegendSectionTitle';

export const FireLegend = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <List
      disablePadding
      dense
      subheader={
        <LegendSectionTitle>{t('map.legends.fires.title')}</LegendSectionTitle>
      }
    >
      <LegendListItem
        iconSrc={wildfireIcons.ActiveFireIcon.data}
        primaryText={t('map.legends.fires.legends.less50.title')}
        secondary={t('map.legends.fires.legends.less50.subtitle')}
      />
      <LegendListItem
        iconSrc={wildfireIcons.ActiveFire50Icon.data}
        primaryText={t('map.legends.fires.legends.more50.title')}
        secondary={t('map.legends.fires.legends.more50.subtitle')}
      />
      <LegendListItem
        iconSrc={wildfireIcons.ActiveFire75Icon.data}
        primaryText={t('map.legends.fires.legends.more70.title')}
        secondary={t('map.legends.fires.legends.more70.subtitle')}
      />
      <LegendListItem
        iconSrc={wildfireIcons.ContainedFireIcon.data}
        primaryText={t('map.legends.fires.legends.contained.title')}
        secondary={t('map.legends.fires.legends.contained.subtitle')}
      />
      <LegendListItem
        iconSrc={wildfireIcons.InactiveFireIcon.data}
        primaryText={t('map.legends.fires.legends.inactive.title')}
        secondary={t('map.legends.fires.legends.inactive.subtitle')}
      />
      <LegendListItem
        iconSrc={wildfireIcons.SilentActiveFireIcon.data}
        primaryText={t('map.legends.fires.legends.silent.title')}
        secondary={t('map.legends.fires.legends.silent.subtitle')}
      />
      <LegendListItem
        iconSrc={wildfireIcons.ActivePrescribedFireIcon.data}
        primaryText={t('map.legends.fires.legends.prescribed.title')}
        secondary={t('map.legends.fires.legends.prescribed.subtitle')}
      />
      <LegendListItem
        iconSrc={wildfireIcons.ScheduledFireIcon.data}
        primaryText={t('map.legends.fires.legends.prescribedScheduled.title')}
        secondary={t('map.legends.fires.legends.prescribedScheduled.subtitle')}
      />
      <LegendListItem
        iconSrc={ComplexFireIcon.data}
        primaryText={t('map.legends.fires.legends.complex.title')}
        secondary={t('map.legends.fires.legends.complex.subtitle')}
      />
    </List>
  );
};
